module.exports = __webpack_public_path__ + "static/media/ethereum-cash.07f368ba.svg";